import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2, Plus, X, Check, Star, Eye, EyeOff } from "lucide-react";
import { api, errMsg } from "../../lib/api";
import { inputCls, btnPrimary, btnGhost, cardCls } from "./styles";

const EMPTY = { name: "", rating: 5, text: "", approved: true };

export const ReviewsTab = () => {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState(null);

  const load = () => api.get("/admin/reviews").then((r) => setItems(r.data)).catch((e) => toast.error(errMsg(e)));
  useEffect(() => { load(); }, []);

  const save = async (e) => {
    e.preventDefault();
    try {
      await api.post("/admin/reviews", form);
      toast.success("تمت الإضافة");
      setForm(null);
      load();
    } catch (err) { toast.error(errMsg(err)); }
  };

  const toggle = async (r) => {
    try {
      await api.put(`/admin/reviews/${r.id}`, { name: r.name, rating: r.rating, text: r.text, approved: !r.approved });
      load();
    } catch (e) { toast.error(errMsg(e)); }
  };

  const del = async (id) => {
    if (!window.confirm("حذف هذا التقييم؟")) return;
    try {
      await api.delete(`/admin/reviews/${id}`);
      toast.success("تم الحذف");
      load();
    } catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <div>
      <div className="flex justify-between items-center mb-5">
        <div className="text-sm text-zinc-500">{items.length} تقييم</div>
        <button data-testid="review-admin-add-btn" onClick={() => setForm(EMPTY)} className={`${btnPrimary} flex items-center gap-1.5`}>
          <Plus className="w-4 h-4" /> إضافة تقييم
        </button>
      </div>

      {form && (
        <form data-testid="review-admin-form" onSubmit={save} className={`${cardCls} mb-5 space-y-3 border-yellow-400/40`}>
          <div className="grid sm:grid-cols-2 gap-3">
            <input data-testid="review-admin-name-input" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="اسم العميل *" className={inputCls} required />
            <select value={form.rating} onChange={(e) => setForm({ ...form, rating: Number(e.target.value) })} className={inputCls}>
              {[5, 4, 3, 2, 1].map((r) => <option key={r} value={r}>{r} نجوم</option>)}
            </select>
          </div>
          <textarea data-testid="review-admin-text-input" value={form.text} onChange={(e) => setForm({ ...form, text: e.target.value })} placeholder="نص التقييم *" rows={2} className={inputCls} required />
          <div className="flex gap-2">
            <button type="submit" data-testid="review-admin-save-btn" className={`${btnPrimary} flex items-center gap-1.5`}><Check className="w-4 h-4" /> حفظ</button>
            <button type="button" onClick={() => setForm(null)} className={btnGhost}><X className="w-4 h-4" /></button>
          </div>
        </form>
      )}

      <div className="space-y-3">
        {items.map((r) => (
          <div key={r.id} data-testid={`review-row-${r.id}`} className={cardCls}>
            <div className="flex items-center justify-between gap-3">
              <div className="flex items-center gap-3">
                <span className="font-bold text-white text-sm">{r.name}</span>
                <span className="flex items-center gap-1 text-yellow-400 text-xs" dir="ltr">
                  <Star className="w-3.5 h-3.5" fill="currentColor" /> {r.rating}
                </span>
                <span className={`text-[10px] border rounded-full px-2 py-0.5 ${r.approved ? "text-green-400 border-green-400/40" : "text-yellow-400 border-yellow-400/40"}`}>
                  {r.approved ? "منشور" : "بانتظار الموافقة"}
                </span>
              </div>
              <div className="flex items-center gap-1">
                <button data-testid={`review-toggle-${r.id}`} onClick={() => toggle(r)} className="text-zinc-400 hover:text-yellow-400 p-1.5 transition-colors" title={r.approved ? "إخفاء" : "نشر"}>
                  {r.approved ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
                </button>
                <button data-testid={`review-delete-${r.id}`} onClick={() => del(r.id)} className="text-zinc-400 hover:text-red-400 p-1.5 transition-colors"><Trash2 className="w-4 h-4" /></button>
              </div>
            </div>
            <p className="text-sm text-zinc-400 mt-2">{r.text}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
